
import React from "react";

export const CustomButton = ({ text, onClick, type = "button", className = "" }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`w-full h-[52px] flex items-center justify-center bg-primary text-white text-[16px] font-bold leading-[100%] tracking-widest py-[15px] px-4 font-grotesk rounded-lg hover:opacity-90 transition duration-300 ${className}`}
    >
      {text}
    </button>
  );
};
